__turbopack_context__.v({
  "slider": "slick-module__zBjEvq__slider",
  "sliderCenter": "slick-module__zBjEvq__sliderCenter",
});
